export enum MapRoute {
  MAP = '/map',
  SWAP_CARD = '/map/swap/:uuid',
}
